import { ChangeDetectionStrategy, Component, computed, inject, viewChild } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { LicenseTypePipe } from 'mbs-ui-shared@components/licenses/pipes/license-type.pipe';
import Computer, { AgentType, convertAgentTypeToNeededCase } from 'mbs-ui-shared@models/Computer';
import { LicenseType } from 'mbs-ui-shared@models/LicenseType.enum';

@Component({
  selector: 'mbs-confirm-assign-license-without-agent-modal',
  templateUrl: './confirm-assign-license-without-agent-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, I18NextPipe, ModalComponent, ModalFooterDirective],
  standalone: true,
  providers: [LicenseTypePipe]
})
export class ConfirmAssignLicenseWithoutAgentModalComponent {
  private readonly licenseTypePipe = inject(LicenseTypePipe);

  protected readonly baseModal = viewChild(ModalComponent);

  protected readonly computer = computed<Computer>(() => this.baseModal().data?.computer);
  protected readonly computerName = computed<string>(() => Computer.getComputerName(this.computer()));
  protected readonly licenseTypeName = computed<string>(() =>
    this.licenseTypePipe.transform(this.baseModal().data?.licenseType as LicenseType)
  );
  protected readonly agentName = computed<string>(() => convertAgentTypeToNeededCase(this.baseModal().data?.agentType as AgentType));

  handleProceed(): void {
    this.baseModal().save();
  }

  handleCancel(): void {
    this.baseModal().close();
  }
}
